import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Redirect } from 'react-router-dom';
import GitInfo from 'react-git-info/macro';
import ga4 from 'react-ga4';
import TagManager from 'react-gtm-module';
import { Provider } from 'react-redux';
import generateStore from './redux/store';

import Layout from './components/Layout/Default';

// Purchase
import HomePage from './containers/Home';
import CategoryPage from './containers/Category';
import ProductPage from './containers/Product';
import CartPage from './containers/Cart';

// Checkout
import Guest from './containers/Guest';
import AddressPage from './containers/Checkout/Address';
import ShippingPage from './containers/Checkout/Shipping';
import PaymentPage from './containers/Checkout/Payment';
import SuccessPage from './containers/Checkout/Success';

// Landing
import BillingRequestPage from './containers/Billing/Request';
import BillingFormPage from './containers/Billing/Form';
import About from './containers/About';
import FAQ from './containers/FAQ';
import Location from './containers/Location';
import Privacy from './containers/Privacy';
import TermsConditions from './containers/TermsConditions';
import NotFound from './containers/NotFound';

import { lang } from './config/config';

const App = () => {
  const store = generateStore();
  const TRACKING_ID = 'G-LK3CRF2ZB1';
  const tagManagerArgs = { gtmId: 'GTM-KP4S5F8' };
  useEffect(() => {
    const gitInfo = GitInfo();
    ga4.initialize(TRACKING_ID);
    TagManager.initialize(tagManagerArgs);
    console.log(`VERSION: ${gitInfo.commit.shortHash}`);
  });

  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Redirect
            path="/mex/es-mx/home&language=en"
            to="/mex/en-us/home"
            exact
          />
          <Redirect
            path="/mex/es-mx/home&language=es"
            to="/mex/es-mx/home"
            exact
          />
          <Redirect path="/" to={`${lang}/category/masvendidos/5`} exact />
          <Layout path={`${lang}/home`} component={HomePage} />
          <Layout path={`${lang}/category/:name`} component={CategoryPage} />
          <Layout path={`${lang}/product`} component={ProductPage} />
          <Layout path={`${lang}/cart`} component={CartPage} />
          <Layout path={`${lang}/guest`} component={Guest} />
          <Layout path={`${lang}/checkout/address`} component={AddressPage} />
          <Layout path={`${lang}/checkout/shipping`} component={ShippingPage} />
          <Layout path={`${lang}/checkout/payment`} component={PaymentPage} />
          <Layout path={`${lang}/checkout/success`} component={SuccessPage} />
          <Layout
            path={`${lang}/billing`}
            component={BillingRequestPage}
            exact
          />
          <Layout path={`${lang}/billing/:id`} component={BillingFormPage} />
          <Layout path={`${lang}/about`} component={About} />
          <Layout path={`${lang}/faq`} component={FAQ} />
          <Layout path={`${lang}/location`} component={Location} />
          <Layout path={`${lang}/privacy`} component={Privacy} />
          <Layout path={`${lang}/terms`} component={TermsConditions} />
          <Layout path="*" component={NotFound} />
        </Switch>
      </Router>
    </Provider>
  );
};

export default App;
